export const formatStringToSnakeCase = (string: string): string => {
  return (string).split(' ').join('_').toLowerCase();
};
